import { getLangCode } from "@/app/(site)/_utils/misc"
import { extractCanonicalCategory } from "@/lib/utils/tracking/productHierarchyUtils"
import {
    CheckoutAPIProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"
import { usePathname } from "next/navigation"
import { sizeLabelsFunction } from "../../../ProductDetail/ProductForm/helpers"

export const useGetProductLangAndCategory = (product: any) => {
    const langCode = getLangCode(usePathname().split("/")[1]) || ""
    const canonicalCategory = extractCanonicalCategory(product)

    return { langCode, canonicalCategory }
}

export const quickShopProductHelperFunction = (
    product: any,
    availableSizesContext: any
) => ({
    productColorName: product?.color_swatch?.color_name,
    productLensName: product?.lens?.lens_name,
    productPrice: product?.price,
    productName: product?.name,
    productUrl: product?.uri,
    isAvailableButNotSelected: availableSizesContext.some(
        (size: { isAvailable: boolean; isSelected: boolean }) =>
            size.isAvailable && !size.isSelected
    ),
    isAnySizeSelected: availableSizesContext.some(
        (size: { isSelected: boolean }) => size.isSelected
    ),
    isSelectedSizeAvailable: availableSizesContext.some(
        (size: { isSelected: boolean; isAvailable: boolean }) =>
            size.isSelected && size.isAvailable
    ),
    isOneSize:
        availableSizesContext.length === 1 &&
        availableSizesContext[0]?.name === "One Size",
    sizeLabels: sizeLabelsFunction(product.items || [])
})

export function hasColorSwatch(
    products: (CheckoutAPIProduct | RelatedProduct)[]
): boolean {
    return products.some(product => product.color_swatch !== undefined)
}
